import { Observable } from 'rxjs'
import { AppState } from 'src/app/core/core.state'
import { environment } from 'src/environments/environment'

import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core'

import { UntilDestroy } from '@ngneat/until-destroy'
import { Dictionary } from '@ngrx/entity'
import { Store } from '@ngrx/store'
import moment from 'moment-mini'
import { BsModalRef } from 'ngx-bootstrap/modal'
import { settingSelectors } from 'src/app/core/settings/settings.selectors'
import { Location } from 'src/app/features/location/location'
import { locationSelectors } from 'src/app/features/location/location.selectors'
import { AccessRights } from 'src/app/features/role/user-role/user-role'
import { Member } from '../../../member/member'
import { memberSelectors } from '../../../member/member.selectors'
import { Organization } from '../../../organization/organization'
import { organizationSelectors } from '../../../organization/organization.selectors'
import { Product } from '../../../product/product'
import { productSelectors } from '../../../product/product.selectors'
import {
  SerieProposal,
  SerieProposalStatus,
  SerieProposalType
} from '../serie-proposal'
import { SerieProposalItem } from '../serie-proposal-item/serie-proposal-item'
import { serieProposalSelectors } from '../serie-proposal.selectors'
import { productActions } from 'src/app/features/product/product.actions'
import { RequestQueryBuilder } from '@nestjsx/crud-request'

@UntilDestroy()
@Component({
  selector: 'serie-proposal-initial-request-general-tab',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class SerieProposalInitialRequestGeneralTabComponent
  implements OnInit
{
  @Output()
  onCloseModal = new EventEmitter<any>()
  @Input()
  serieProposal: SerieProposal
  @Input() isFromModal: boolean = false

  public moduleConfigs: any = environment.moduleConfigs
  public accessRights = AccessRights
  public isLoading$: Observable<boolean>
  public memberEntities$: Observable<Dictionary<Member>>
  public productEntities$: Observable<Dictionary<Product>>
  public locationEntities$: Observable<Dictionary<Location>>
  public serieProposalItem: SerieProposalItem
  public organizationEntities$: Observable<Dictionary<Organization>>
  public daysOfWeek: number[] = [1, 2, 3, 4, 5, 6, 7]
  public selectedLanguage$: Observable<string>
  public serieProposalType = SerieProposalType
  public serieProposalStatus = SerieProposalStatus
  public bsModalRef: BsModalRef

  get selectedDays(): number[] {
    return this.serieProposal.details.initialRequest.repeatableBookings.map(
      (booking) => booking.dayOfWeek
    )
  }

  constructor(
    private store: Store<AppState>,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.isLoading$ = this.store.select(serieProposalSelectors.selectIsLoading)

    this.selectedLanguage$ = this.store.select(
      settingSelectors.selectById,
      'language'
    )

    this.store.dispatch(
      productActions.fetchOneById({
        id: this.serieProposal.details.initialRequest.productId,
        params: RequestQueryBuilder.create({
          join: [{ field: 'translations' }]
        })
      })
    )

    this.memberEntities$ = this.store.select(memberSelectors.selectEntities)
    this.organizationEntities$ = this.store.select(
      organizationSelectors.selectEntities
    )

    this.productEntities$ = this.store.select(productSelectors.selectEntities)
    this.locationEntities$ = this.store.select(locationSelectors.selectEntities)
  }

  public getSerieProposalDates() {
    return {
      startDate: moment(this.serieProposal.startDate).toDate(),
      endDate: moment(this.serieProposal.endDate).toDate()
    }
  }

  public isDaySelected(day: number): boolean {
    return this.selectedDays.includes(day)
  }

  public getTimesForDay(dayNumber: number): {
    startTime: string
    endTime: string
  } {
    let repeatableBookings =
      this.serieProposal.details.initialRequest.repeatableBookings

    if (!repeatableBookings?.length) {
      return { startTime: null, endTime: null }
    }
    const repeatableBooking = repeatableBookings.find(
      (booking: { dayOfWeek: number }) => booking.dayOfWeek === dayNumber
    )

    if (repeatableBooking) {
      return {
        startTime: repeatableBooking.startTime.slice(0, 5),
        endTime: repeatableBooking.endTime.slice(0, 5)
      }
    } else {
      return { startTime: null, endTime: null }
    }
  }
}
